module.exports = __webpack_public_path__ + "static/media/2.d3d212b8.jpg";